import { FC } from "react";
import ButtonComponent from "../../../../common/components/button/button.component";
import ModalComponent, {
  ModalProps,
} from "../../../../common/components/modal/modal.component";
import htmlParser from "../../../../common/utils/html-parser/html-parser.service";
import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import orderRouteEditCancelEditConfirmationHelper from "./order-route-edit-cancel-edit-confirmation.helper";

type OrderRouteEditCancelEditConfirmationProps = Pick<
  ModalProps,
  "isOpen" | "onClose"
> & {
  onConfirm: () => void;
  cargoCompanyOrderId: number | undefined;
};

const OrderRouteEditCancelEditConfirmationComponent: FC<
  OrderRouteEditCancelEditConfirmationProps
> = (props) => {
  if (props.cargoCompanyOrderId === undefined) {
    return null;
  }

  const translations =
    orderTranslationsHelper.getDetailsTranslations().cancelOrderRequest
      .confirmationModal;

  const contentText =
    orderRouteEditCancelEditConfirmationHelper.getContentMessageText(
      props.cargoCompanyOrderId
    );

  return (
    <ModalComponent
      header={{ title: translations.headingText }}
      isOpen={props.isOpen}
      onClose={props.onClose}
      actions={[
        <ButtonComponent
          type="danger"
          onClick={props.onConfirm}
          title={translations.confirmationButtonTitle}
        >
          {translations.confirmationButtonText}
        </ButtonComponent>,
        <ButtonComponent
          type="brand"
          onClick={props.onClose}
          title={translations.rejectButtonTitle}
        >
          {translations.rejectButtonText}
        </ButtonComponent>,
      ]}
    >
      {htmlParser.parse(contentText)}
    </ModalComponent>
  );
};

export default OrderRouteEditCancelEditConfirmationComponent;
